import { iterateKeys } from "../../../../../../Common/IterableUtils";

import { UnitId, unitIdToLegacyUnitId } from "./UnitId";

export interface UnitIdImmutableSet {
    [unitId: string]: true;
}

export class UnitIdSet {
    public static create(): UnitIdImmutableSet {
        return {};
    }

    public static isEmpty(set: UnitIdImmutableSet): boolean {
        for (const _key of iterateKeys(set)) {
            return false;
        }
        return true;
    }

    public static hasItem(set: UnitIdImmutableSet, unitId: UnitId): boolean {
        return set[unitIdToLegacyUnitId(unitId)] === true;
    }

    public static add(set: UnitIdImmutableSet, unitId: UnitId): UnitIdImmutableSet {
        if (set[unitIdToLegacyUnitId(unitId)] === true) {
            return set;
        }
        return {
            ...set,
            [unitIdToLegacyUnitId(unitId)]: true,
        };
    }

    public static remove(set: UnitIdImmutableSet, unitId: UnitId): UnitIdImmutableSet {
        if (set[unitIdToLegacyUnitId(unitId)] !== true) {
            return set;
        }
        const result: UnitIdImmutableSet = { ...set };
        delete result[unitIdToLegacyUnitId(unitId)];
        return result;
    }
}
